import { http } from '@/utils/request'
import type { PaginationParams, PaginationResult } from '@/api/types'

export interface UserInfoData {
    id: string,
    username?: string,
    phone?: string,
    email?: string,
    password?: string,
    nickname?: string,
    realName?: string,
    avatar?: string,
    company?: string,
    profession?: string,
    city?: string,
    remark?: string
    lastLoginTime?: string
}

export interface UserInfo {
    code: number,
    data: UserInfoData,
    msg: string
}

export interface UserQueryParams extends PaginationParams {
    username?: string
    nickname?: string
    status?: number
}

export interface CaptchaResponse {
    uuid: string
    image: string
}

export interface VerifyCaptchaParams {
    uuid: string
    code: string
}

export interface SendSmsCodeParams {
    phone: string
    uuid: string
    code: string
    clientId: string
}

export interface SmsLoginParams {
    phone: string
    smsCode: string
}

// 用户相关 API
export const userApi = {
    // 获取用户列表
    getUsers: (params: UserQueryParams) =>
        http.get<PaginationResult<UserInfo>>('/users', params),

    // 获取用户详情
    getUserDetail: () =>
        http.get<UserInfo>(`/user/info`),

    // 创建用户
    createUser: (data: Partial<any>) =>
        http.post<{ code: number; msg?: string; data?: { downloadUrl?: string } }>('/auth/register', data),

    // 更新用户
    updateUser: (id: number, data: Partial<UserInfo>) =>
        http.put<UserInfo>(`/users/${id}`, data),

    // 删除用户
    deleteUser: (id: number) =>
        http.delete(`/users/${id}`),

    // 修改密码
    changePassword: (data: { oldPassword: string; newPassword: string }) =>
        http.put('/users/password', data),

    // 上传头像
    uploadAvatar: (file: File) =>
        http.upload('/users/avatar', file),

    // 获取图形验证码
    getCaptcha: () =>
        http.get<CaptchaResponse>('/auth/code'),

    // 验证图形验证码
    verifyCaptcha: (params: VerifyCaptchaParams) =>
        http.post<{ valid: boolean }>('/auth/captcha/verify', params),

    // 发送短信验证码
    sendSmsCode: (params: SendSmsCodeParams) =>
        http.post<{ code: number; msg?: string; data?: any }>('/auth/sms/send', params),

    // 短信验证码登录
    codeLogin: (params: SmsLoginParams) =>
        http.post<{ code: number; msg?: string; data?: any }>('/auth/smsLogin', params)

}